import mapCustomerInformationFields from "../../../lib/mapCustomerInformationFields";
import {
  getTLDsFromCart,
  getOnecomConfig,
  getCustomerInformationFromLocalStorage,
  getAddonProductsInCart,
  isDomainPresent,
  hasVPSInCart,
} from "../../selectors";

import { loadUserDataFromSession } from "../loadUserDataFromSession/loadUserDataFromSession";
import { loadCountryRestrictions } from "../loadCountryRestrictions/loadCountryRestrictions";
import { setCountryCodeInSession } from "../setCountryCodeInSession/setCountryCodeInSession";
import { goToRoute } from "../goToRoute/goToRoute";

export const loadCustomerInformationFields = ({
  customerType = "PRIVATE",
  isRegistrant = true,
  country,
  includeOptions = true,
  firstTimeLoad,
  citizenship = null,
}) => {
  return async (dispatch, getState, { api }) => {
    const { countryCode } = getOnecomConfig(getState());
    let tlds = getTLDsFromCart(getState()).join(", ");
    const isDomain = isDomainPresent(getState());
    const addonProducts = getAddonProductsInCart(getState());
    const activeFormFromStore = getState().customerInformation.activeForm;
    const hasVPS = hasVPSInCart(getState());

    if (!isDomain && !hasVPS) {
      dispatch(goToRoute({ pageName: "domainSearch" }));
    }

    let userSavedValues = null;

    // Check if user data is stored in the the backend
    const payload = await dispatch(loadUserDataFromSession());

    const savedData =
      activeFormFromStore === "registrantForm"
        ? payload.data.registrant
        : payload.data.customer;

    if (firstTimeLoad && payload.wasSuccessful && savedData) {
      const { customer, registrant, isSame } = payload.data;

      userSavedValues =
        activeFormFromStore === "registrantForm" ? registrant : customer;

      if (firstTimeLoad && userSavedValues) {
        country = isSame ? registrant.country : customer.country;
        customerType = isSame ? registrant.type : customer.type || "PRIVATE";
        isRegistrant =
          activeFormFromStore === "customer" ? isSame : isRegistrant;
      }
    }
    // If user data is not stored in the backend
    // Check if user data is saved in the localStorage
    else if (!userSavedValues) {
      const retrievedCustomerInformationData =
        getCustomerInformationFromLocalStorage(getState());
      if (retrievedCustomerInformationData) {
        const { activeForm, customer, registrant, isSame } =
          retrievedCustomerInformationData;

        if (activeForm === "registrantForm") {
          userSavedValues = registrant;
          country = registrant && registrant.country;
          citizenship = citizenship || (registrant && registrant.citizenship);
          customerType = (registrant && registrant.type) || customerType;
        } else {
          userSavedValues = customer;
          isRegistrant = typeof isSame === "boolean" ? isSame : isRegistrant;
          country = customer && customer.country;
          citizenship = citizenship || (customer && customer.citizenship);

          customerType = (customer && customer.type) || customerType;
        }
        citizenship = !firstTimeLoad && citizenship ? citizenship : null;
      }
    }

    country = country || countryCode;

    if (activeFormFromStore === "customer") {
      // Default countryCode in the session based on country value from the Owner form
      await dispatch(setCountryCodeInSession(country));
    }

    const exchangeProducts = [
      "EXCHANGE_ONLINE",
      "EXCHANGE_M365_BUSINESS_BASIC",
      "EXCHANGE_M365_BUSINESS_STANDARD",
    ];

    const isExchangeAmongAddons = addonProducts.some(({ name }) =>
      exchangeProducts.includes(name),
    );

    if (isExchangeAmongAddons) {
      // Check if Exchange is restricterd
      await dispatch(loadCountryRestrictions(country));
    }

    return api
      .getCustomerInformationFields(
        customerType.toUpperCase(),
        country,
        tlds,
        isRegistrant,
        citizenship,
        includeOptions,
      )
      .then(
        (data) => {
          if (data.result.relevantFields.length > 0) {
            const fieldsToRender = mapCustomerInformationFields(
              data.result.relevantFields,
              userSavedValues,
            );

            return {
              wasSuccessful: true,
              fields: fieldsToRender,
              isSame: isRegistrant,
            };
          }

          return {
            wasSuccessful: false,
          };
        },
        (err) => {
          return { wasSuccessful: false };
        },
      );
  };
};
